import { CustomHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useEditWorkflowPermissionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { usePermissionsContext } from '../../../PermissionsContext'
import { buildEditPermissionInputFromRecord } from '../../../utils'
import { WorkflowPermissionRecord } from '../../../types'

export function useBulkActions(): CustomHeaderActionOptions<WorkflowPermissionRecord>[] {
  const {
    fetching,
    modals: {
      addUsers: { toggle },
    },
    refetch,
    selection: { records: selectedPermissions, setRowKeys },
  } = usePermissionsContext()
  const [editPermission, { loading: editing }] =
    useEditWorkflowPermissionMutation(DefaultMutationHookOptions)
  const disabledBulkReason = fetching
    ? { message: 'Loading' }
    : selectedPermissions.length
    ? undefined
    : { message: 'Select at least one permission' }

  async function bulkClearUsers() {
    await Promise.all(
      selectedPermissions.map((permission) =>
        editPermission({
          variables: {
            input: buildEditPermissionInputFromRecord(permission, []),
          },
        })
      )
    )
    await refetch()
    simpleEditNotification('Permissions')
    setRowKeys([])
  }

  return [
    {
      text: 'Add Users',
      type: 'default',
      placement: 'right',
      permission: 'admin',
      disabled: disabledBulkReason,
      onClick: () => toggle(null),
    },
    {
      text: 'Clear Users',
      type: 'default',
      placement: 'right',
      permission: 'admin',
      disabled: disabledBulkReason,
      onClick: () => {},
      confirm: {
        title:
          'Clear all users from selected permissions? This action cannot be undone.',
        okButtonProps: {
          loading: editing,
          disabled: editing,
        },
        onConfirm: bulkClearUsers,
      },
    },
  ]
}
